import { useShallow } from 'zustand/react/shallow';
import { useTreeStore } from '../store/TreeStore';
import { useParameterStore } from '../store/ParameterStore';
import { operationTypes } from '@/types/operationTypes';
import { Operation } from '@/backend/models/operation';
import { ParameterType } from '@/types/parameterTypes';
import { Parameter } from '@/backend/models/parameter';
import { CUSTOM_FIELD_TYPES } from '@/types/customFieldTypes';

export interface IncompleteOperations {
  incompleteFileOperations: Operation[];
  incompleteCodeOperations: Operation[];
  erroredCodeOperations: Operation[];
  imcompleteStepInputParameters: Parameter[];
  incompleteFieldInputs: Operation[];
}

export function useGetIncompleteOperations(parentId?: string, stepId?: string): IncompleteOperations {
  const operations = useTreeStore(useShallow((state) => state.getStoreOperationsForParent(parentId || '')));
  const parameters = useParameterStore(state => state.parameters);

  const parametersForSubjectAndType = useParameterStore(state => state.parametersForSubjectAndType);
  const imcompleteStepInputParameters: Parameter[] = [];
  const stepParameters = parametersForSubjectAndType(stepId || '', ParameterType.INPUT);
  stepParameters.forEach(param => {
    if (param.hasEmptyField()) {
      imcompleteStepInputParameters.push(param);
    }
  });

  const incompleteFileOperations: Operation[] = [];
  const incompleteCodeOperations: Operation[] = [];
  const erroredCodeOperations: Operation[] = [];
  const incompleteFieldInputs: Operation[] = [];

  operations.forEach(op => {
    if (op.type === operationTypes.Code) {
      if (!op.code?.lastRanAt) {
        incompleteCodeOperations.push(op);
      }
      if (op.code?.returnCode !== 0) {
        erroredCodeOperations.push(op);
      }
    } else if (op.type === operationTypes.FileInput) {
      const parameter = parameters.find(p => p.subjectId === op.id);
      if (!parameter?.fields[0]?.file) {
        incompleteFileOperations.push(op);
      }
    } else if (op.type === operationTypes.FieldInput) {
      const parameter = parameters.find(p => p.subjectId === op.id);
      if (parameter?.fieldType === CUSTOM_FIELD_TYPES.File && !parameter.fields[0]?.file) {
        incompleteFileOperations.push(op);
      }
      if (parameter?.fields[0]?.isRequired && parameter.hasEmptyField()) {
        incompleteFieldInputs.push(op);
      }
    }
  });

  return {
    incompleteFileOperations,
    incompleteCodeOperations,
    erroredCodeOperations,
    imcompleteStepInputParameters,
    incompleteFieldInputs,
  };
}